<template>
    <div class="tabs-container flex">
      <div class="tab-item text-center" v-for="(item, index) in list" :key="index" @click="onTabClick(item)">
        <img :src="imgView(item.icon)" alt="icon">
        <div class="tab-item-name">{{ item.name }}</div>
      </div>
    </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
import { AppType } from '@/constants/appType'
import wx from 'weixin-js-sdk'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    };
  },
  methods: {
    imgView(img) {
      return QNImageUtil.imageView(img)
    },
    resolveUrl(raw) {
      if (raw == null || String(raw).trim() === '') return ''
      let path = String(raw).trim()
      const placeholder = '${unionMatchId}'
      if (path.indexOf(placeholder) !== -1) {
        const id = this.$route.params.unionMatchId
        if (id == null || id === '') return ''
        path = path.split(placeholder).join(String(id))
      }
      return path
    },
    onTabClick(item) {
      const raw = item.url
      if (raw == null || String(raw).trim() === '') return
      const type = item.type || 'native'
      const path = this.resolveUrl(raw)
      if (!path) return

      if (type === 'native') {
        this.$router.push(path)
        return
      }

      if (type === 'h5') {
        let url = path
        if (!/^https?:\/\//i.test(url)) {
          url = 'https://' + url
        }
        if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: `/pages/webview/index?redirect=${encodeURIComponent(url)}`
          })
        } else {
          window.location.href = url
        }
        return
      }

      if (type === 'mini') {
        if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
          const miniPath = path.startsWith('/') ? path : '/' + path
          wx.miniProgram.navigateTo({ url: miniPath })
        }
      }
    }
  },
};
</script>
<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.tabs-container{
  font-size: 14px;
  color: #3D3D3D;
  flex-wrap: wrap;
  margin-bottom: -25px;
  .tab-item{
    min-width: 56px;
    width: 20%;
    margin-bottom: 25px;
  }
  img{
    width: 30px;
    height: 30px;
  }
}
</style>
